import { render, staticRenderFns } from "./ListPengiriman.vue?vue&type=template&id=13ecdaf6&"
import script from "./ListPengiriman.vue?vue&type=script&lang=js&"
export * from "./ListPengiriman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports